import React from 'react';
import { Instagram, Facebook, Youtube, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-stone-950 text-stone-400 py-20 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
        
        {/* Logo - Neutral Aesthetic */}
        <div className="text-center md:text-left">
            <h2 className="font-logo text-3xl text-stone-100 mb-2">Anavaran.</h2>
            <p className="text-[9px] uppercase tracking-[0.2em] text-stone-500 ml-1">Films</p>
        </div>

        {/* Social Icons with Brand Colors */}
        <div className="flex gap-8">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-[#E4405F] transition-colors duration-300"><Instagram size={20} strokeWidth={1.5} /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-[#FF0000] transition-colors duration-300"><Youtube size={20} strokeWidth={1.5} /></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-[#1877F2] transition-colors duration-300"><Facebook size={20} strokeWidth={1.5} /></a>
            <a href="mailto:info@anavaranfilms.com" className="text-stone-400 hover:text-stone-100 transition-colors duration-300"><Mail size={20} strokeWidth={1.5} /></a>
        </div>

        {/* Copyright */}
        <div className="text-center md:text-right">
            <p className="text-xs font-light tracking-wide">
              &copy; {new Date().getFullYear()} <span className="text-stone-300">Anavaran Films</span>
            </p>
            <p className="text-[10px] text-stone-600 mt-1 uppercase tracking-wider">All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
};